// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ModalTrainingFormModuleLayout} from 'app_components/modules/admin/landings/modalTrainingForm'
// @end

// @import events
// @end

// @import utils
import { I18nUtil } from 'app_utils/i18n'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import services
import LandingService from 'app_services/admin/landings/landingService'
import ReactSelectService from 'app_services/components/reactSelectService'
// @end

// @import types
import {ITrainingFields} from 'app_types/admin/landings/landingTypes'
// @end

// @ADD Component types
interface IModalTrainingFormModuleProps {
  source: string
  open: boolean
  handleClose: (data:any)=>void
  editData?: any
  fields?: Array<ITrainingFields>
}
interface IModalTrainingFormModuleState {
  customErrors: any
  processing: boolean
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ModalTrainingFormModule extends Component<IModalTrainingFormModuleProps, IModalTrainingFormModuleState> {

  private reactSelectService: ReactSelectService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil
  private landingService: LandingService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IModalTrainingFormModuleProps) {
    super(props)
    this.state = {
      customErrors: null,
      processing: false
    }
    this.reactSelectService = new ReactSelectService()
    this.i18nUtil = new I18nUtil()
    this.landingService = new LandingService()
    this.screenNotifications = new ScreenNotificationsUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  onHandleSubmit = async (data: any) => {
    this.setState({processing: true, customErrors: null})

    let customErrors: any = {}

    // @INFO: Si existen campos con error retorno
    if (Object.keys(customErrors).length > 0) {
      this.setState({customErrors, processing: false})
      return false
    }

    if (data.platform_video) {
      data['platform_video'] = this.reactSelectService.formatReactSelectResponse(data.platform_video)
    }
    if (data.course) data['course'] = this.reactSelectService.formatReactSelectResponse(data.course)

    const landingResponse = await this.landingService.saveTraining(
      {...data, slug: this.props.source},
    )

    if (landingResponse) {
      let screen_notification_label = 'components.screen_notifications.update'

      this.screenNotifications.fireToast(
        {
          message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'top',
        }
      )
      this.setState({processing: false})
      this.props.handleClose({status: true, data})
    }

    this.setState({processing: false})
  }

  render() {
    return(
      <ModalTrainingFormModuleLayout
        open={this.props.open}
        handleClose={this.props.handleClose}
        onHandleSubmit={this.onHandleSubmit}
        customErrors={this.state.customErrors}
        processing={this.state.processing}
        editData={this.props.editData}
        fields={this.props.fields}
      />
    )
  }
}

export default connect(mapStatesToProps)(ModalTrainingFormModule)
